var render = function render(){var _vm=this,_c=_vm._self._c;return (false)?_c('div',{staticClass:"user-acknowledge"},[_c('div',{staticClass:"title"},[_vm._v("众多合作伙伴的一致认可")]),_c('div',{staticClass:"sub-title"},[_vm._v("感谢每一位合作伙伴的信任")]),_c('div',{staticClass:"card-wrap"},_vm._l((_vm.topList),function(item,index){return _c('div',{key:index,staticClass:"card"})}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }